module.exports = __webpack_public_path__ + "img/fk.b4efb2a3.svg";